import flagUSA from "../images/american.flag.png"
import flagAm from "../images/FlagAm.png"
import flagRu from "../images/FlagRu.png"

export const languagesData = [
    {
        id: 1,
        img: flagAm,
        name: 'am',
        active: true
    },
    {
        id: 2,
        img: flagUSA,
        name: 'en',
        active: false
    },
   
    {
        id: 3,
        img: flagRu,
        name: 'ru',
        active: false
    },
]